module.exports = __webpack_public_path__ + "media/images/icons/twotone/environment-a6f3aeb063a51d4696c91d630f738440.svg";